import React, { useContext } from "react";
import {
  PaymentContext,
  PaymentContextValue,
} from "../contexts/Payment/payment.context";
import Countdown from "react-countdown";

interface ButtonProps {
  text: string;
  className?: string;
  onClick?: any;
  img?: any;
  type?: any;
  loading?: boolean;
  disabled?: boolean;
  isResend?: boolean;
}


export const LoaderCircle = ({ color = "white", size = 4 }) => (
  <svg
    className={`animate-spin h-${size} w-${size} mr-1 mt-px text-${color}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path
      className="opacity-75"
      fill="currentColor"
      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
    />
  </svg>
);

export const PrimaryButton = ({
  width = "full",
  text,
  className,
  loading,
  disabled,
  isResend,
  id,
  ...otherProps
}: {
  width?: string;
  text: string;
  className?: string;
  loading?: boolean;
  disabled?: boolean;
  isResend?: boolean;
  onClick?: any;
  id: string;
}) => {
  const { state }: PaymentContextValue = useContext(PaymentContext);
  const { checkoutSettings } = state.business || {};

  const widthClass = {
    full: "w-full",
    64: "w-64",
    56: "w-56",
    48: "w-48",
    36: "w-36",
    sm: "w-sm",
  }[width];

  const inTenMins = new Date(Date.now() + 10 * 60 * 1000);
  const CountdownRenderer = ({ formatted }) => {
    return formatted.minutes === "00"
      ? `${formatted.seconds}`
      : `${formatted.minutes}:${formatted.seconds}`;
  };

  return (
    <button
      disabled={loading || disabled}
      className={`flex justify-center items-center rounded-xl p-3 space-x-1 text-sm text-white ${widthClass} font-semibold opacity-95 hover:opacity-100 disabled:opacity-50 transition-all ${className}`}
      style={{
        background:
          checkoutSettings?.buttonColor ||
          "linear-gradient(135deg, var(--SarepayPrimary-color) 0%, var(--Checkout-accent-color) 100%)",
        color: checkoutSettings?.buttonTextColor || "#ffffff",
        borderColor: checkoutSettings?.buttonColor || "transparent",
      }}
      id={id}
      {...otherProps}
    >
      {loading && <LoaderCircle />}
      <span className={"mt-px block"}>{text}</span>

      {isResend && <Countdown date={inTenMins} renderer={CountdownRenderer} />}
    </button>
  );
};


export const PinLoaderCircle = () => {
  const { state }: PaymentContextValue = useContext(PaymentContext);
  const { checkoutSettings } = state.business || {};

  return (
    <svg
      className="w-12 h-12 mt-px mr-1 duration-200 animate-spin text-primary"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      style={{
        animationDuration: "0.5s",
        color: checkoutSettings?.fontColor,
      }}
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
};
